(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency.active || 'USD',
      minimumFractionDigits: 2,
    });

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-hidden', count === 0);
      });
    }

    function updateShippingBar(cartTotal) {
      const bar = document.getElementById('cart-shipping-bar');
      if (!bar) return;
      const threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) return;
      const remaining = Math.max(0, threshold - cartTotal);
      const pct = Math.min(100, Math.round((cartTotal / threshold) * 100));
      const msg = document.getElementById('cart-shipping-msg');
      const fill = document.getElementById('cart-shipping-fill');
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (remaining === 0) {
          msg.innerHTML = '<strong>You\'ve unlocked free shipping!</strong>';
        } else {
          msg.innerHTML = 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from free shipping';
        }
      }
    }

    function changeLineItem(key, quantity) {
      const row = document.querySelector('[data-item-row][data-key="' + key + '"]');
      if (row) row.classList.add('is-loading');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (quantity === 0) {
            // Remove the row
            if (row) {
              row.style.transition = 'opacity 0.2s ease, max-height 0.3s ease';
              row.style.overflow = 'hidden';
              row.style.opacity = '0';
              row.style.maxHeight = '0';
              setTimeout(function () { row.remove(); }, 320);
            }
          } else {
            // Update qty display
            const qtyDisplay = document.querySelector('[data-qty-display="' + key + '"]');
            if (qtyDisplay) qtyDisplay.textContent = quantity;

            // Update qty button data attrs
            document.querySelectorAll('[data-key="' + key + '"]').forEach(function (btn) {
              if (btn.dataset.qty !== undefined) btn.dataset.qty = quantity;
            });

            // Update line price
            const lineItem = cart.items.find(function (i) { return i.key === key; });
            const priceEl = document.querySelector('[data-line-price="' + key + '"]');
            if (priceEl && lineItem) {
              priceEl.textContent = formatMoney(lineItem.final_line_price);
            }

            if (row) row.classList.remove('is-loading');
          }

          // Update subtotal
          const subtotalEl = document.getElementById('cart-subtotal');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

          // Update item count heading
          const countEl = document.querySelector('.cart-page__count');
          if (countEl) {
            countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
          }

          updateShippingBar(cart.total_price);
          updateCartCount(cart.item_count);

          return cart;
        })
        .catch(function () {
          if (row) row.classList.remove('is-loading');
        });
    }

    // Qty buttons
    document.getElementById('cart-items').addEventListener('click', function (e) {
      const btn = e.target.closest('[data-action="increase"], [data-action="decrease"]');
      if (!btn) return;
      const key = btn.dataset.key;
      const current = parseInt(btn.dataset.qty, 10);
      const next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      changeLineItem(key, next);
    });

    // Remove buttons
    document.getElementById('cart-items').addEventListener('click', function (e) {
      const btn = e.target.closest('[data-action="remove"]');
      if (!btn) return;
      changeLineItem(btn.dataset.key, 0);
    });

    // Upsell add-to-cart (AJAX, then reload to refresh cart rows)
    document.querySelectorAll('[data-upsell-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = form.querySelector('[data-upsell-btn]');
        const originalText = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;

        const variantId = form.querySelector('[name="id"]').value;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            // Reload to update cart items list
            window.location.reload();
          })
          .catch(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    function swapSection(targetUrl, push) {
      var sectionEl = document.querySelector('.collection[data-section-id]');
      if (!sectionEl) {
        window.location.href = targetUrl;
        return;
      }
      var sectionId = sectionEl.getAttribute('data-section-id');
      var fetchUrl = targetUrl + (targetUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

      sectionEl.classList.add('is-filter-loading');

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('fetch failed: ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newSection = doc.querySelector('.collection[data-section-id]');
          if (!newSection) throw new Error('section not in response');

          sectionEl.outerHTML = newSection.outerHTML;

          if (push) {
            window.history.pushState({ collectionFilter: true }, '', targetUrl);
          }

          var tabs = document.querySelector('.collection__filter-tabs');
          if (tabs) {
            var top = tabs.getBoundingClientRect().top + window.pageYOffset - 16;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function () {
          window.location.href = targetUrl;
        });
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('.collection__filter-tab');
      if (!tab) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var href = tab.getAttribute('href');
      if (href) swapSection(href, true);
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.collectionFilter) {
        swapSection(window.location.href, false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';

    var dialog  = document.querySelector('[data-nav-drawer]');
    var panel   = dialog && dialog.querySelector('[data-nav-drawer-panel]');
    var trigger = document.querySelector('[data-nav-drawer-trigger]');
    var closer  = dialog && dialog.querySelector('[data-nav-drawer-close]');

    if (!dialog || !panel || !trigger) return;

    function openDrawer() {
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      // Double-RAF: ensures one paint cycle completes with the panel at
      // translateX(-100%) before .is-open is applied, so the CSS
      // transition actually fires instead of snapping to the end state.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
        });
      });
    }

    function closeDrawer() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.addEventListener('transitionend', function onEnd() {
        panel.removeEventListener('transitionend', onEnd);
        dialog.close();
      });
    }

    trigger.addEventListener('click', openDrawer);

    if (closer) {
      closer.addEventListener('click', closeDrawer);
    }

    // Backdrop click: the dialog is full-screen and transparent,
    // so a click on the dialog element itself (not its children) is
    // always a click outside the panel.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDrawer();
    });

    // Escape key: intercept the native 'cancel' event so the dialog
    // doesn't close instantly and our slide-out animation plays.
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeDrawer();
    });

    // ── Product strip arrows ──
    document.querySelectorAll('[data-product-strip]').forEach(function (strip) {
      var scrollEl = strip.querySelector('[data-ps-scroll]');
      var prevBtn  = strip.querySelector('[data-ps-prev]');
      var nextBtn  = strip.querySelector('[data-ps-next]');
      if (!scrollEl || !prevBtn || !nextBtn) return;

      var SCROLL_AMT = 260; // ~2 cards

      function updateArrows() {
        var atStart = scrollEl.scrollLeft <= 2;
        var atEnd   = scrollEl.scrollLeft >= scrollEl.scrollWidth - scrollEl.clientWidth - 2;
        prevBtn.classList.toggle('is-visible', !atStart);
        prevBtn.setAttribute('aria-hidden', atStart ? 'true' : 'false');
        nextBtn.classList.toggle('is-visible', !atEnd);
        nextBtn.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
      }

      scrollEl.addEventListener('scroll', updateArrows, { passive: true });
      prevBtn.addEventListener('click', function () { scrollEl.scrollBy({ left: -SCROLL_AMT, behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function () { scrollEl.scrollBy({ left:  SCROLL_AMT, behavior: 'smooth' }); });
      updateArrows();
    });

    // ── Desktop mega menu: reflect open state + Escape to close ──
    var megaItems = document.querySelectorAll('.header__mega-nav [data-mm-item]');
    megaItems.forEach(function (item) {
      var trigger = item.querySelector('[data-mm-trigger]');
      if (!trigger) return;
      function setOpen(open) { trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      item.addEventListener('mouseenter', function () { setOpen(true); });
      item.addEventListener('mouseleave', function () {
        if (!item.contains(document.activeElement)) setOpen(false);
      });
      item.addEventListener('focusin', function () { setOpen(true); });
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var active = document.activeElement;
      var item = active && active.closest ? active.closest('.header__mega-nav [data-mm-item]') : null;
      if (!item) return;
      var trigger = item.querySelector('[data-mm-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const variantDataEl = document.getElementById('product-variant-data');
    if (!variantDataEl) return;
    const variantData = JSON.parse(variantDataEl.textContent);

    const form = document.getElementById('product-form');
    if (!form) return;

    const variantIdInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const comparePriceEl = document.getElementById('product-compare-price');
    const badgeEl = document.getElementById('product-badge');
    const addBtn = document.getElementById('add-to-cart');
    const addBtnText = document.getElementById('add-to-cart-text');
    const qtyInput = document.getElementById('product-qty');

    // Quantity buttons
    const qtyMinus = form.querySelector('.product__qty-minus');
    const qtyPlus = form.querySelector('.product__qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', () => {
        const val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', () => {
        const val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Variant selection
    const optionSelects = form.querySelectorAll('.product__option-select');
    if (optionSelects.length === 0) return;

    function updateSelectedVariant() {
      const selected = Array.from(optionSelects).map(s => s.value);
      const matched = variantData.find(v => v.options.every((opt, i) => opt === selected[i]));
      if (!matched) return;

      if (variantIdInput) variantIdInput.value = matched.id;
      if (priceEl) priceEl.textContent = matched.price;
      if (comparePriceEl) {
        if (matched.compare_at_price) {
          comparePriceEl.textContent = matched.compare_at_price;
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (badgeEl) {
        if (matched.badge) {
          badgeEl.textContent = matched.badge;
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
      if (addBtn && addBtnText) {
        addBtn.disabled = !matched.available;
        // Respect contact-for-pricing text if already set by Liquid
        if (addBtnText.textContent.trim() !== 'Request a Quote') {
          addBtnText.textContent = matched.available ? 'Add to Cart' : 'Sold Out';
        }
      }

      // Gallery switch
      if (matched.featured_image) {
        const gallery = document.querySelector('[data-product-gallery]');
        if (gallery) {
          const thumbs = gallery.querySelectorAll('.product__gallery-thumb img');
          thumbs.forEach((img, i) => {
            if (img.src.includes(matched.featured_image.split('?')[0].split('/').pop())) {
              gallery.querySelectorAll('.product__gallery-thumb')[i].click();
            }
          });
        }
      }
    }

    optionSelects.forEach(s => s.addEventListener('change', updateSelectedVariant));
  })();

  } catch(e) { console.error(e); }
})();
})();
